import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import iconEdit from "@iconify/icons-eva/edit-2-fill";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import DeleteIcon from "@mui/icons-material/Close";
import RemoveIcon from "@mui/icons-material/Remove";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Switch, Button, Checkbox, TableRow, TableBody, TableCell, Container, Typography, TableContainer, TablePagination, RadioGroup, Radio, FormControlLabel, TextField, IconButton, InputBase } from "@mui/material";
// components
import Page from "../../components/Page";
import Label from "../../components/Label";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";
import { UserListHead, UserListToolbar } from "../../components/_dashboard/user";
// import USERLIST from '../_mocks_/user';

import axios from "axios";
import { BASE_URL } from "src/config/constants";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import Uploader from "src/components/uploader/Uploader";
import { alert } from "src/services/alert";
import Confirm from "src/components/common/ConfirmDialog";
import ListToolbar from "src/components/common/ListToolbar";
import MyPagination from "src/components/common/MyPagination";
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "id", label: "ID", alignRight: false },
  { id: "name", label: "规格名称", alignRight: false },
  { id: "keys", label: "商品规格", alignRight: false },
  { id: "values", label: "商品属性", alignRight: false },
  { id: "" },
];


const moreMenus = [
  { title: "编辑", icon: iconEdit },
  { title: "删除", icon: iconDelete },
];

export default function ProductAttr() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [action, setAction] = useState("");
  const [targetAttr, setTargetAttr] = useState({});
  const [pairs, setPairs] = useState([]);

  const [form, setForm] = useState({
    name: "",
    key: "",
    value: "",
    valueNew: "",
  });

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });


  useEffect(() => {
    axios
      .post("/store/attr/all", filter)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          setItems(data);
        }
      })
      .catch((err) => {});
  }, [filter]);


  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  function handleAddBanner() {
    setAction("add");
    setForm({
      name: "",
      image: "",
      isShow: 1,
    });
  }

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`edit/${row.id}`);
      setTargetAttr({ ...row });
      setAction("edit");
      setForm({
        ...form,
        name: row.name,
      });

      const value = JSON.parse(row.value).map(v => ({ key: v.key, value: v.value.split(','), valid: true }));

      setPairs(value);
    } else if (type === "删除") {
      handleDelAttr(row.id);
    }
  };

  function handleDelAttr(id) {
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      onConfirm() {
        axios
          .post("/store/attr/del", { id })
          .then((res) => {
            const { code, msg, data } = res.data;
            if (code === 1) {
              setItems(items.filter((b) => b.id !== id));
            } else {
              alert(msg);
            }
          })
          .catch((err) => {
            console.log("删除规格失败: ", err);
          });
      },
    });
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleDialogConfirm() {
    if (!form.name) return alert("规格名称不能为空");
    if (!pairs.length) return alert("至少填一种规格");

    const value = StringUtil.serialize(pairs.map(p => ({
      key: p.key,
      value: p.value.join(',')
    })));
    // console.log(StringUtil.serialize(value));

    const formData = { 
      name: form.name,
      value
    };

    if (action === "edit") {
      formData.id = targetAttr.id;
    }

    axios
      .post(action === "add" ? "/store/attr/add" : "/store/attr/edit", formData)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          if (action === "add") {
            setItems([...items, data]);
          } else if (action === "edit") {
            const attr = items.find((b) => b.id === targetAttr.id);
            attr.name = formData.name;
            attr.value = value;
            setItems([...items]);
          }

          setAction("");
          reset();
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加或修改规格失败: ", err);
      });
  }

  function handleAddNewAttr() {
    const _pairs = [...pairs];
    _pairs.push({
      key: "",
      value: [],
      valid: false,
    });

    setPairs(_pairs);
  }

  function handleAddPair(idx) {
    const _pairs = [...pairs];
    const { key, value } = form;
    if (!key || !value) return alert("名字不能为空");

    _pairs[idx].key = form.key;
    _pairs[idx].value = [form.value];
    _pairs[idx].valid = true;

    setPairs(_pairs);
    setForm({
      ...form,
      key: "",
      value: [],
    });
  }

  function handleRemovePair(idx = -1) {
    const _pairs = [...pairs];
    _pairs.splice(idx, 1);
    setPairs(_pairs);
  }

  function handleNewValueChange(e) {
    console.log(e.target.value);
    handleIptChange("valueNew", e.target.value.trim());
  }

  function handleRemoveValue(i, j) {
    const _pairs = [...pairs];
    _pairs[i].value.splice(j, 1);

    setPairs(_pairs);
  }

  function handleAddValue(idx) {
    if (!form.valueNew || !form.valueNew.trim()) return alert('值不能为空');
    const _pairs = [...pairs];
    _pairs[idx].value.push(form.valueNew.trim());
    setPairs(_pairs);
    setForm({
      ...form,
      valueNew: "",
    });
  }

  function reset() {
    setPairs([]);
    setForm({
      name: '',
      key: '',
      value: '',
      valueNew: ''
    });
  }

  const isUserNotFound = items.length === 0;

  return (
    <Page title="商品规格">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            商品规格
          </Typography>

          <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={handleAddBanner}>
            添加规格
          </Button>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead headLabel={TABLE_HEAD} />

                <TableBody>
                  {items.map((row) => {
                    // const { id, name, role, status, company, avatarUrl, isVerified } = row;
                    const { id, name, value, isShow, createdAt } = row;

                    const v = JSON.parse(value);
                    const keys = v.map((a => a.key)).join('\n');
                    const values = v.map((a => a.value)).join('\n');


                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" >
                        <TableCell align="left">{id}</TableCell>
                        <TableCell align="left">{name}</TableCell>
                        <TableCell align="left"><pre>{keys}</pre></TableCell>
                        <TableCell align="left"><pre>{values}</pre></TableCell>
                        {/* <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell> */}

                        <TableCell align="right">
                          <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>

      <FormDialog sx={{ minWidth: 1000 }} maxWidth="1000px" title={action === "add" ? "添加规格" : "修改规格"} open={!!action} onClose={() => { reset(); setAction();}} onConfirm={handleDialogConfirm}>
        <FormItem title="规格模板" required>
          <TextField fullWidth placeholder="请输入规格模板名称" autoComplete="off" id="name" value={form.name} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
        </FormItem>

        {pairs.map((p, i) => {
          const { key, value, valid } = p;
          if (valid) {
            return (
              <Stack key={i}>
                <Stack direction="row" alignItems="center">
                  <Typography gutterBottom>{key}</Typography>
                  <IconButton onClick={() => handleRemovePair(i)}>
                    <DeleteIcon />
                  </IconButton>
                </Stack>
                <Stack direction="row" alignItems="center">
                  {value.map((v, j) => (
                    <Stack direction="row" alignItems="center" key={j} sx={{ border: "1px solid #aaa", borderRadius: 1 }}>
                      <FiberManualRecordIcon sx={{ width: 14, color: "#00AB55" }} />
                      <Typography>{v}</Typography>
                      <IconButton onClick={() => handleRemoveValue(i, j)}>
                        <RemoveIcon />
                      </IconButton>
                    </Stack>
                  ))}

                  <Stack direction="row" alignItems="center" sx={{ border: "1px solid #aaa", borderRadius: 1 }}>
                    <InputBase value={form.valueNew} onChange={handleNewValueChange} sx={{ width: 100 }} />
                    <Button variant="contained" onClick={() => handleAddValue(i)}>
                      添加
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            );
          }
          return (
            <Stack direction="row" alignItems="center" key={i}>
              <FormItem title="规格名称" required>
                <TextField fullWidth placeholder="请输入规格名称" autoComplete="off" id="key" value={form.key} size="small" onChange={(e) => handleIptChange("key", e.target.value.trim())} />
              </FormItem>
              <FormItem title="规格值" required>
                <TextField fullWidth placeholder="请输入规格值" autoComplete="off" id="value" value={form.value} size="small" onChange={(e) => handleIptChange("value", e.target.value.trim())} />
              </FormItem>

              <Button variant="contained" onClick={() => handleAddPair(i)}>
                确认
              </Button>
              <Button variant="outlined" onClick={() => handleRemovePair(i)}>
                取消
              </Button>
            </Stack>
          );
        })}

        {(!pairs.length || pairs[pairs.length - 1].valid) && (
          <Button variant="contained" onClick={handleAddNewAttr}>
            添加新规格
          </Button>
        )}
      </FormDialog>
    </Page>
  );
}
